const BoostYourLinkSection = () => {
    return (
        <div className="boost-link">
            <h2>Boost Your link today</h2>
            <button>Get started</button>
        </div>
    );
}

export default BoostYourLinkSection;